/*
 * @Author: your name
 * @Date: 2021-09-06 09:49:03
 * @LastEditTime: 2022-01-04 11:01:39
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\api\index\indexApi.js
 */
import { postFetch, getFetch } from '@/utils/request'

//获取首页banner图片集合
export function getIndexBannerList(provinceId,cityId) {
    return getFetch('/index/getIndexBannerList', {"provinceId":provinceId,"cityId":cityId})
}

//获取小banner宣传集合
export function getSmallBannerList(provinceId,cityId) {
    return getFetch('/index/getSmallBannerList', {"provinceId":provinceId,"cityId":cityId})
}

//获取热销推荐相关商品
export function getHotSellRecommend(cityId,showNum) {
    return getFetch('/index/getHotSellRecommend',  {"cityId":cityId,"showNum":showNum})
}

//获取耗材推荐相关商品
export function getConsumablesRecommend(cityId) {
    return getFetch('/index/getConsumablesRecommend', {"cityId":cityId})
}

//获取试剂推荐相关商品
export function getReagentRecommend(cityId) {
    return getFetch('/index/getReagentRecommend', {"cityId":cityId})
}

//获取仪器推荐相关商品
export function getInstrumentRecommend(cityId) {
    return getFetch('/index/getInstrumentRecommend', {"cityId":cityId})
}

//获取限时特价相关商品
export function getIndexTimeLimitGoods(cityId,showNum) {
    return getFetch('/index/getIndexTimeLimitGoods', {"cityId":cityId,"showNum":showNum})
}

//获取新品首发相关商品
export function getNewGoods(cityId) {
    return getFetch('/index/getNewGoodsOnlineRecommend', {"cityId":cityId})
}

//按需定制
export function customerNeedCustomize(params) {
    return postFetch('/customerNeedCustomize/saveCustomerNeedCustomize',null, params)
}

//获取首页导航推荐
export function getIndexNavigation(cityId) {
    return getFetch('/index/getIndexNavigation', {"cityId":cityId})
}

//获取首页顶部banner推荐
export function getIndexTopBannerList(cityId) {
    return getFetch('/index/getIndexTopBannerList', {"cityId":cityId})
}

//获取腰间图片集合
export function getMiddleBannerList(cityId) {
    return getFetch('/index/getMiddleBannerList', {"cityId":cityId})
}

//获取未确认的订单数据量
export function getNotConfirmedByCustomerAccountId(){
    return getFetch('/order/getNotConfirmedByCustomerAccountId',{})
}


// WEBPACK FOOTER //
// ./src/api/index/indexApi.js